
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
export class TripartiteInformationManagementApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'tripartite-information-management'
    }
    public  tripartiteServiceManagement(current,size,projectId){

        return this.send({currentL:current,size:size, projectId:projectId},"tripartiteServiceManagement",Methods.GET)
    }

}
